import { BaseAction } from "../../../core/actions/BaseAction";
import { getRecoilStateValueWithType, updateRecoilStateWithType } from "../../../Orchestrator/Recoils/Events/Recoil";
import { IMultiBookingTrainOffer } from "../../../Orchestrator/Recoils/MultiBookingAtom";
import { TrainTypeEnum } from "../../../Orchestrator/Types/Enums/globalDefaultEnum";

interface IToggleMultiBookingTrainCheckboxActionParams {
  type: TrainTypeEnum;
  train: IMultiBookingTrainOffer;
}

export class ToggleMultiBookingTrainCheckboxAction extends BaseAction<void, IToggleMultiBookingTrainCheckboxActionParams> {
  override async run(): Promise<void> {
    const { type, train } = this.params!;

    let multiBookingSelectedTrainsState = getRecoilStateValueWithType("multiBookingSelectedTrainsAtom");

    if (!multiBookingSelectedTrainsState || multiBookingSelectedTrainsState.length === 0) return;

    multiBookingSelectedTrainsState = multiBookingSelectedTrainsState.map(item => {
      if (item.date === train.date) {
        if (type === TrainTypeEnum.outbound) {
          return {
            ...item,
            outbound: {
              ...item.outbound,
              selected: !Boolean(item.outbound.selected)
            }
          } as IMultiBookingTrainOffer
        } else if (type === TrainTypeEnum.inbound) {
          return {
            ...item,
            inbound: {
              ...item.inbound,
              selected: !Boolean(item.inbound?.selected)
            }
          } as IMultiBookingTrainOffer
        }
        return item;
      }
      return item;
    })

    updateRecoilStateWithType("multiBookingSelectedTrainsAtom", multiBookingSelectedTrainsState)
  }
}

export const toggleMultiBookingTrainCheckboxAction = new ToggleMultiBookingTrainCheckboxAction();
